import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=f143545e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f143545e')) {
      api.createRecord('f143545e', component.options)
    } else {
      api.reload('f143545e', component.options)
    }
    module.hot.accept("./NotesView.vue?vue&type=template&id=f143545e", function () {
      api.rerender('f143545e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/NotesView.vue"
export default component.exports